<app-loader [hidden]="!showLoader"></app-loader>
<div class="table-top">
  <div *ngIf="workflowDataList && workflowDataList.length; else noData">
    <app-workflow-filter-bar
      [workflowFilterData]="filterData"
      [initialWorkflowResponse]="workflowDataList"
      (inputSearch)="onSearchInput($event)"
      (selectRegion)="onRegionSelect($event)" (selectAsset)="onAssetSelect($event)"
      (selectDeposit)="onDepositSelect($event)" (clearFilterSelection)="onClearFilter()" [loadFilters]="loadAllFilters">
    </app-workflow-filter-bar>
    <div *ngFor="let workflowData of workflowDataList">
      <app-form-header class="tab-section" *ngIf="!showAssetName" [title]="workflowData.regionName"></app-form-header>
      <app-form-header class="tab-section" *ngIf="showAssetName" [title]="workflowData.assetName"></app-form-header>
      <app-workflow-table-grid *ngIf="!isCpQpNomination" [headers]="workflowData.headers" [data]="workflowData.data"
        [noRecordTxt]="'No workflows found'" [searchText]="searchText" (onExport)="onExportExcel($event)"
        (onLink)="openLink($event)" (onLockUnlock)="onLockUnlock($event)" (onConsentEvent)="onConsentEvent($event)"
        (onCpQpReport)="onSelectCpQpReport($event)">
      </app-workflow-table-grid>
      <app-workflow-table-grid
      *ngIf="isCpQpNomination"
      [isCpQpNomination]="true"
      [headers]="workflowData.headers"
      [data]="workflowData.data"
      [noRecordTxt]="'No workflows found'"
      [isCPQPUser]="true"
      [showActions]="true"
      (onLink)="openNominationLink($event)"
      (onViewNomination)="viewNomination($event)"
      [searchText]="searchText"
    ></app-workflow-table-grid>
    </div>
  </div>
  <ng-template #noData>
    <div class="no-data" *ngIf="workflowDataList && !workflowDataList.length">{{ noWorkflowsText }}</div>
  </ng-template>
</div>
<app-view-log-history
  *ngIf="showViewLogHistoryPopUp"
  [viewLogArray]="viewLogArray"
  [viewLogHeaderName]="viewLogHeaderName"
  (onCancel)="onCloseViewLogHistoryPopup()"
></app-view-log-history>
